import { HOME_INSPECTION_DETAILS_NAME } from "../../constants";
import { Maybe, SystemOrSubsystem, TemplateSubsystemType, TemplateSystemType } from "../../types";

export const sortByDisplayIndexAndHomeDetails = (a: SystemOrSubsystem, b: SystemOrSubsystem) => {
  if (a.name === HOME_INSPECTION_DETAILS_NAME) return -1;
  if (b.name === HOME_INSPECTION_DETAILS_NAME) return 1;

  const aIndex = a.displayIndex ?? -1;
  const bIndex = b.displayIndex ?? -1;

  return aIndex - bIndex || a.name.localeCompare(b.name);
};

export const sortByDisplayIndex = <T extends { displayIndex?: Maybe<number> }>(a: T, b: T) => {
  const aIndex = a.displayIndex ?? -1;
  const bIndex = b.displayIndex ?? -1;
  return aIndex - bIndex;
};

export const sortTemplateSystemOrSubsystemByDisplayIndex = (
  items: (TemplateSystemType | TemplateSubsystemType)[],
) => [...items].sort((a, b) => {
  if (a.displayIndex === b.displayIndex) return 0;
  if (a.displayIndex === null) return -1;
  if (b.displayIndex === null) return 1;
  return (a.displayIndex || 0) < (b.displayIndex || 0) ? -1 : 1;
});
